import { render, staticRenderFns } from "./TypeWellMissCount.vue?vue&type=template&id=13da655c&scoped=true"
import script from "./TypeWellMissCount.vue?vue&type=script&lang=ts"
export * from "./TypeWellMissCount.vue?vue&type=script&lang=ts"
import style0 from "./TypeWellMissCount.vue?vue&type=style&index=0&id=13da655c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da655c",
  null
  
)

export default component.exports